import { render, staticRenderFns } from "./customerAccount.vue?vue&type=template&id=0a801fcf&scoped=true&"
import script from "./customerAccount.vue?vue&type=script&lang=js&"
export * from "./customerAccount.vue?vue&type=script&lang=js&"
import style0 from "./customerAccount.vue?vue&type=style&index=0&id=0a801fcf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a801fcf",
  null
  
)

export default component.exports